var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSmCoinActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M24 6.75V12c0 3.32-5.38 6-12 6S0 15.32 0 12V6.75C0 3 5.38 0 12 0s12 3 12 6.75z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6.75,
    fill: "#F6C354",
    rx: 10.5,
    ry: 5.25
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCA93B",
    d: "M3 11.2A10.67 10.67 0 0 1 1.5 10v2A3 3 0 0 0 3 14.19V11.2zM6.75 12.81A17.68 17.68 0 0 1 4.5 12v3a17.64 17.64 0 0 0 2.25.79v-2.98zM11.25 13.47a27.47 27.47 0 0 1-3-.31v3a23.29 23.29 0 0 0 3 .31v-3zM15.75 13.16a27.47 27.47 0 0 1-3 .31v3a23.29 23.29 0 0 0 3-.31v-3zM19.5 12a17.68 17.68 0 0 1-2.25.8v3a17.64 17.64 0 0 0 2.25-.79V12zM22.5 10c-.46.447-.963.849-1.5 1.2v3a3 3 0 0 0 1.5-2.2v-2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 6.22,
    fill: "#DCA93B",
    rx: 7.72,
    ry: 3.33
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmCoinActive);
export default __webpack_public_path__ + "static/media/ic_sm_coin_active.475e35055126a5d1287d0f89786cbf27.svg";
export { ForwardRef as ReactComponent };